export const _search = [
    {
        title: 'Curador urbano',
        content: 'Luis carlos parra salazar curador urbano 1 de bucaramanga, El Curador Urbano es un particular encargado de estudiar, tramitar y expedir licencias urbanísticas a petición del interesado en adelantar proyectos de esta índole.',
        link: '/curator'
    },
    {
        title: 'Transparencia y acceso a la información pública',
        content: 'En cumplimiento a la Ley 1712 del 6 de marzo de 2014 la Curaduría Urbana No.1 de Bucaramanga pone a disposición de la ciudadanía la siguiente información.',
        link: '/transparency'
    },
    {
        title: 'Mision y vision',
        content: 'Convertirnos en ejemplo de compromiso y calidad en la verificación del cumplimiento de las Licencias Urbanísticas y demás actuaciones.',
        link: '/mision'
    },
    {
        title: 'Licencias y Trámites',
        content: 'En la página usted encontrará todo lo referente a los servicios que brindamos a la comunidad información de trámites y consultas, orientación sobre la aplicación de normas urbanísticas.',
        link: '/whatwedo'
    },
    {
        title: 'Procesos y Procedimientos',
        content: 'Procedimiento para la expedición licencias urbanísticas',
        link: '/organization'
    },
    {
        title: 'Normatividad',
        content: 'Información de todas las normas urbanísticas y constructivas, entre las cuales se pueden encontrar las leyes, decretos nacionales, resoluciones y decretos municipales.',
        link: '/normogram'
    },
    {
        title: 'Curaduria inclusiva - Ley 982 DE 2005',
        content: 'El Centro de Relevo del Ministerio de las Tecnologías de la Información y las Comunicaciones (MinTIC), está en alianza con la Federación Nacional de Sordos De Colombia (Fenascol), dedicada a la labor de promover el uso de las TIC en beneficio de las personas con discapacidad auditiva de Colombia. ',
        link: '/inclusivity'
    },
    {
        title: 'Publicaciones ',
        content: 'Publicaciones de notificaciones, actos administrativos y otros avisos, citaciones y respuestas por parte de la curaduría 1 de Bucaramanga.',
        link: '/administrative'
    },
    {
        title: 'Repositorio antiguo / actual',
        content: 'Histórico de todas las normas, licencias que se han expedido, tanto las del curador anterior como el curador actual.',
        link: '/old'
    },
    {
        title: 'Noticias ',
        content: 'Noticias y avisos importantes de la curaduría 1 de Bucaramanga.',
        link: '/news'
    },
    {
        title: 'Documentos de apoyo.',
        content: 'Documentos y formatos que sirven de apoyo para realizar radicaciones, entre los cuales se puede encontrar el formato de generar vaya informativa o incluso se puede generar vaya en línea, Instructivos, herramientas.',
        link: '/file'
    },
    {
        title: 'Consulta estado de procesos.',
        content: 'La curaduría urbana no.1 de Bucaramanga coloca a su disposición esta herramienta, con el fin de dar seguimiento a su petición, así mismo puede consultar el estado del trámite de su solicitud.',
        link: '/status'
    },
    {
        title: 'Preguntas frecuentes',
        content: 'Cuestionario de preguntas y respuestas más frecuentes.',
        link: '/faq'
    },
    {
        title: 'Agendamiento de Citas.',
        content: 'En caso de requerirlo usted puede solicitar una cita con cualquiera de los profesionales de la Curaduría N°1 de Bucaramanga.',
        link: '/scheduling'
    },
    {
        title: 'Liquidador de expensas.',
        content: 'Las expensas es el ingreso que percibe el curador urbano por los servicios prestados, tiene como finalidad cubrir los gastos en que incurre para desarrollar su labor; tales como el pago del grupo interdisciplinario, los costos operativos y la remuneración del curador urbano.',
        link: '/liquidator'
    },
    {
        title: 'Peticiones, quejas, reclamos, sugerencias y denuncias (pqrs)',
        content: 'A través de este medio, todo usuario deberá presentar peticiones, quejas, reclamos y sugerencias ante la Curaduría Urbana N°1 de Bucaramanga.',
        link: '/pqrs'
    },
    {
        title: 'Contactese con nosotros',
        content: 'Información de contacto para que se pueda comunicar con nosotros vía telefónica, WhatsApp, correo., además podrá consultar nuestros horarios de atención.',
        link: ',/mailbox'
    },
    {
        title: 'Certificación para profesionales ',
        content: 'La Curaduria Urbana N°1 de Bucaramanga ofrece a los profesionales que figuran en las actuaciones urbanísticas, la certificación de participación y responsabilidad en la calidad profesional en la que haya actuado en los proyectos de licenciamiento. ',
        link: '/certificacion'
    }
]